import {
  Button,
  Dialog,
  Text,
} from '@noorden-insurtech/alba-design-system';
import { CheckCircle2 } from 'lucide-react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function ConfirmFinalizationModal({ isOpen, onClose, onConfirm }: Props) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[560px] max-w-[92vw] rounded-[24px] bg-[#F9F9F9] p-0 shadow-xl'>
          <div className='flex flex-col gap-4 p-6'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title>
                <div className='flex items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <CheckCircle2 className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Confirmar finalização
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full p-0'>
              <Text className='text-sm text-alba-gray-700'>
                Tem certeza que deseja finalizar a cotação?
              </Text>
              <Text className='text-sm text-alba-gray-600 mt-2'>
                A cotação será aprovada automaticamente se atender aos critérios
                de aceitação. Caso contrário, poderá ser encaminhada para
                análise técnica da Alba, podendo trazer alteração de valor ou
                recusa após avaliação do risco.
              </Text>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0'>
              <div className='flex w-full items-center justify-end gap-3'>
                <Button variant='ghost' size='large' onClick={onClose}>
                  Cancelar
                </Button>
                <Button variant='primary' size='large' onClick={onConfirm}>
                  Confirmar
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
